import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DataManager } from '@syncfusion/ej2-data';
import { TranslateService } from '@ngx-translate/core';
import { saveAs as importedSaveAs } from "file-saver";
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { NotifyService } from '../../services/notify.service';
import { SidebarService } from '../../sidebar/sidebar.service';
import { AuthenService } from '../../services/authen.service';
import { Router } from '@angular/router';
import { UrlParams } from '../../helpers/url-params';
import { MasterBase } from '../../base/master-base';
import * as AppConst from '../../data/test.data';
import { MyImportFileDialogComponent } from "../../dialogs/my-import-file-dialog/my-import-file-dialog";
import { ChangeEventArgs } from '@syncfusion/ej2-buttons';
import { Util } from '../../helpers/global.util';

@Component({
    selector: 'sc-matrix-page',
    templateUrl: './sc-matrix-page.html',
})
export class SCMatrixPageComponent extends MasterBase implements OnInit, OnDestroy {
    @ViewChild('dlgImport') dlgImport: MyImportFileDialogComponent;
    waiting: boolean = false;    
    nameValueFields: Object = { text: 'Name', value: 'Value' };    

    constructor(auth: AuthenService, http: HttpService, helper: HelperService, notify: NotifyService, translate: TranslateService, private sidebar: SidebarService, private router: Router) {
        super(auth, http, helper, notify, translate);

        this.searchOpts = [
            { label: 'None', value: 0 },
            { label: 'FFM User Code', value: 1 },
            { label: 'SC User Code', value: 2 },
            { label: 'Customer Code/Name', value: 3 }
        ]
    }

    ngOnDestroy() {
    }

    ngOnInit() {
        this.onSearch();
    }

    onSearch() {
        let params = new UrlParams();
        params.add('ffmUserCode', this.searchType == 1 ? (this.searchValue == null ? '' : this.searchValue) : '');
        params.add('scUserCode', this.searchType == 2 ? (this.searchValue == null ? '' : this.searchValue) : '');
        params.add('custSearch', this.searchType == 3 ? (this.searchValue == null ? '' : this.searchValue) : '');

        this.gridData = this.http.getByManager(`api/Util/GetSCPage?${params.toString()}`, this.auth);
    }

    onExport() {
        let params = new UrlParams();
        params.add('ffmUserCode', this.searchType == 1 ? (this.searchValue == null ? '' : this.searchValue) : '');
        params.add('scUserCode', this.searchType == 2 ? (this.searchValue == null ? '' : this.searchValue) : '');
        params.add('custSearch', this.searchType == 3 ? (this.searchValue == null ? '' : this.searchValue) : '');

        this.waiting = true;
        this.http.download(`api/Util/ExportSCMatrix?${params.toString()}`, res => {
            let fileNameExport = 'CRM_SCMatrix.xlsx';
            importedSaveAs(res, fileNameExport);
            this.waiting = false;
        });
    }

    onImport() {
        this.dlgImport.show('api/Util/ImportSCMatrix', null, res => {
            this.grid.refresh();
        });
    }

    onDelete(id: number) {
        this.helper.confirm('Are you sure you want to remove this item ?', () => {
            this.http.delete(`api/Util/RemoveSCMatrix/${id}`, res => {
                this.grid.refresh();
            });
        });
    }
    
    
}
